<template>
    <v-dialog
            v-model="process"
            persistent
            width="300">
        <v-card
                color="primary"
                dark>
            <v-card-text>Please wait
                <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                />

            </v-card-text>
        </v-card>
    </v-dialog>

</template>

<script>
  export default {
    name: "Loader",
    data() {
      return {
        process: true
      }
    }
  }
</script>

<style scoped>

</style>
